import React from "react";

export default function PlatformList({ links }) {
  return (
    <div className="flex gap-4 items-center">
      {links.map((link) => (
        <a
          href={link.url}
          target="_blank"
          className="hover:scale-125 transition-all duration-300"
        >
          {link.platformIcon}
        </a>
      ))}
    </div>
  );
};
